import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import ats1 from '../../img/ATS PANEL/ats1.png';
import ats2 from '../../img/ATS PANEL/ats2.jpg';

function ATSPanel() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="ats-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">🔁 ATS Panel (Automatic Transfer Switch Panel)</h2>
              <p className="text-muted">
                Seamless automatic power transfer for uninterrupted operations.
              </p>
              <p className="text-muted fw-semibold">ATS Panel &nbsp; | &nbsp; Electric Low Voltage Panel</p>
            </div>

            {/* Application */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                ATS panels are used to automatically switch the power source from the main supply to a backup generator or secondary source during a power failure. Widely used in hospitals, data centers, commercial buildings, telecom towers, and critical infrastructure to ensure uninterrupted power supply.
              </p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={ats1}
                  alt="ATS Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={ats2}
                  alt="Automatic Transfer Switch Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 415V, 3-phase, 50Hz</li>
                <li><strong>Current Rating:</strong> 40A to 6300A</li>
                <li><strong>Transfer Time:</strong> ≤ 1–5 seconds (typical)</li>
                <li><strong>Type:</strong> Contactor-based / MCCB / Motorized ACB</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 61439-1 & 2</strong> – LV panel assemblies</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Automatic or manual source switching between grid and genset</li>
                <li>Smart controller with real-time monitoring and alarms</li>
                <li>Safe interlocking system to prevent back-feed</li>
                <li>Delay timer and voltage sensing for stable changeover</li>
                <li>Bypass mode for maintenance</li>
                <li>SCADA/BMS integration ready</li>
                <li>Compact, modular design with IP42–IP54 protection</li>
              </ul>
            </div>

            {/* CTA */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Need ATS Panels for Your Facility?</h5>
              <p className="mb-2 text-muted">
                We provide reliable ATS panel solutions for critical and uninterrupted power transitions.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default ATSPanel;
